import axios from "axios"
import qs from 'qs'

const Axios = axios.create({
    timeout: 5000,
    responseType: "json",
    baseURL: process.env.BASE_API, // 需自定义
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
});

Axios.interceptors.request.use(
    config => {
      // let userInfo = store.state.permissions.userInfo;//用来获取本地存储的accessToken数据
      // if (userInfo.accessToken) {
      //   config.headers['Authorization'] = userInfo.accessToken;//设置请求头
      // }
      // if (config.mask !== false) {//设置请求等待过程的页面动画,使用ElementUI中的loading动画
      //   loadAll = Loading.service({
      //     lock: true,
      //     text: '加载中',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.4)'
      //   });
      // }
      return config;
    },
    err => {
      return Promise.reject(err);
    });

    Axios.interceptors.response.use(
        response => {
          // setTimeout(function () {
          //   loadAll.close();
          // }, 500);
        //   返回成功的回调函数
          if (response.status === 200) {
            //操作成功返回数据
            return response.data;
          }
        },
        // 返回错误的回调函数
        error => {
          // Message({
          //   showClose: true,
          //   message: '请求失败，请重试',
          //   type: 'error'
          // });
          // setTimeout(function () {
          //   loadAll.close();
          // }, 500);
        //   过滤返回的错误码,根据不同的错误码执行不同的函数
          if (error.response) {
            switch (error.response.status) {
                case 400:
                    error.message = '错误请求';
                    break;
                case 401:
                    error.message = '未授权，请重新登录';
                    break;
                case 403:
                    error.message = '拒绝访问';
                    break;
                case 404:
                    error.message = '请求错误,未找到该资源';
                    break;
                case 405:
                    error.message = '请求方法未允许';
                    break;
                case 408:
                    error.message = '请求超时';
                    break;
                case 500:
                    error.message = '服务器端出错';
                    break;
                case 501:
                    error.message = '网络未实现';
                    break;
                case 502:
                    error.message = '网络错误';
                    break;
                case 503:
                    error.message = '服务不可用';
                    break;
                case 504:
                    error.message = '网络超时';
                    break;
                case 505:
                    error.message = 'http版本不支持该请求';
                    break;
                default:
                    error.message = `未知错误${error.response.status}`;
            }
            return Promise.reject(error)
          }
        }
      );
    /*网络请求部分*/

/*
 *  get请求
 *  url:请求地址
 *  params:参数
 * */
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        Axios({
            url: url,
            method: 'get',
            params: params
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

/*
 *  post请求
 *  url:请求地址
 *  params:参数
 * */
export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
        Axios({
            url: url,
            method: 'post',
            data: qs.stringify(params)
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

/*
 *  文件上传
 *  url:请求地址
 *  params:参数
 * */
export function fileUpload(url, params = {}) {
    return new Promise((resolve, reject) => {
        Axios({
            url: url,
            method: 'post',
            data: params,
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

export default {
    get,
    post,
    fileUpload
}


// WEBPACK FOOTER //
// ./src/utils/axios.js